import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onGetDocumentListSuccess = (
  payload = {},
  type = types.SUCCESS_DOCUMENT_LIST
) => {
  return {
    type,
    payload
  };
};

export const isDocumentListLoading = (
  payload = {},
  type = types.LOADING_DOCUMENT_LIST
) => {
  return {
    type,
    payload
  };
};
